import { Component } from '@angular/core';
import { constants } from 'src/constants/constants';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
	constants = constants;
}
